<template>
    <div class="popup popup-about" v-bind:class="{active: isShow}">
        <div class="content-block">
            <div class="pop-nav">
                <a href="JavaScript: void(0)" class="close-popup" @click="onClose">
                    <img src="https://resource.rcclchina.com.cn/tui2/user_center/arrow_back.png">
                </a>
                <div class="pop-nav-title">使用规则</div>
            </div>
            <div class="coupon-popup-bg"></div>
            <div id="coupon-popup-content" v-html="currentRule"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Popup',
        props: {
            isShow: {
                type: Boolean,
                default: false
            },
            currentRule: {
                type: String,
                default: ''
            },
            onClose: {
                type: Function
            }
        }
    }
</script>

<style lang="less" scoped>
    .popup-about{
        display: block;
        position: fixed;
        width: 100%;
        height: 100%;
        overflow: hidden;
        background-color: #fff;
        transform: translate3d(100%, 0, 0);
        -webkit-transform: translate3d(100%, 0, 0);
        -webkit-transition-duration: 400ms;
        transition-duration: 400ms;
    }
    .popup-about.active{
        transform: translate3d(0, 0, 0);
        -webkit-transform: translate3d(0, 0, 0);
    }
    .pop-nav {
        display: block;
        position: relative;
        height: 50px;
    }

    .pop-nav a {
        width: 50px;
        position: absolute;
        display: block;
        height: 100%;
        z-index: 1;
    }

    .pop-nav a img {
        width: 10px;
        position: relative;
        left: 20px;
        top: 16px;
    }

    .pop-nav-title {
        position: relative;
        top: 15px;
        text-align: center;
    }

    .popup .content-block{
        padding: 0;
        margin: 0;
        width: 100%;
        height: 100%;
        overflow: auto;
    }
    .coupon-popup-bg {
        height: 10px;
        background-color: #F6F7F8;
    }
    #coupon-popup-content{
        padding: 14px 21px;
        
        font-size: 12px;
        color: #666666;
        letter-spacing: 0;
        line-height: 20px;
    }
</style>
